<template>
  <section class="main-layout__box">
    <badges-list />

    <!-- BADGES END  -->
    <add-btn @onClick="openModalWindow" />

    <modal :show="deleteModal" :showBtn="false" :dark="true" @close="toggleDeleteModal">
      <delete-modal
        :title="$t('global.areUsure').toString()"
        :cancelDeletionTag="false"
        @cancel="toggleDeleteModal"
        @next="removeAction"
      />
    </modal>

    <modal :show="showModal" @close="toggleModal" :dark="true">
      <badge-modal @close="toggleModal" />
    </modal>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import badgeModal from '@/components/modals/badges/badgeModal'
import addBtn from '@/components/controls/addBtn'
import badgesList from '../../components/lists/badges/badgesList'

export default {
    name: 'filtersView',
    components: {
        badgeModal,
        badgesList,
        addBtn,
    },
    computed: {
        ...mapGetters({
            badges: 'badges/badges',
            showModal: 'badges/showModal',
            deleteModal: 'badges/deleteModal',
            badge: 'badges/badge',
            isUpdate: 'badges/isUpdate',
            deletedId: 'badges/deletedId',
        }),
    },
    methods: {
        ...mapMutations({
            setState: 'badges/setState',
            clearModal: 'badges/clearModal',
        }),
        ...mapActions({
            remove: 'badges/remove',
        }),
        toggleDeleteModal() {
            this.setState({
                key: 'deleteModal',
                value: !this.deleteModal,
            })
        },
        toggleModal() {
            this.setState({
                key: 'showModal',
                value: !this.showModal,
            })
        },
        openModalWindow() {
            this.clearModal()
            this.setState({
                key: 'isUpdate',
                value: false,
            })
            this.toggleModal()
        },
        removeAction() {
            this.remove(this.deletedId)
            this.setState({
                key: 'deleteModal',
                value: false,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";
// $height: 52px;

// @mixin padding {
//   padding: 20px 0 20px;
// }

// // FILTERS START
// .filters {
//   padding: 0 0 20px;

//   &:not(:first-child) {
//     margin-top: 20px;
//   }

//   &__head {
//     padding: 0 20px;
//     &_flex {
//       display: flex;
//       align-items: center;
//     }

//     &_between {
//       justify-content: space-between;
//     }
//   }

//   &-view {
//     // border-radius: 8px;
//     // background-color: #ffffff;
//     // width: 100%;
//     // height: 100%;
//     // top: 0;
//     // left: 0;
//     // overflow-y: auto;
//     // box-sizing: border-box;

//     border-radius: 8px;
//     box-sizing: border-box;
//     height: 90%;
//     overflow-y: scroll;
//   }

//   &__title {
//     font-size: 18px;
//     font-family: $fontMedium;
//     color: #4d4d4d;
//     margin: 0;
//     height: 30px;
//   }

//   &__button {
//     font-family: $fontMedium;
//     height: 100%;
//     background-color: #71bd4a;
//     color: #fff;
//     border: none;
//     width: 80px;
//     padding: 7px 0;
//     font-size: 14px;
//     border-radius: 8px;
//   }

//   &__add {
//     position: fixed;
//     right: 25px;
//     bottom: 25px;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     -webkit-box-align: end;
//     -ms-flex-align: end;
//     align-items: flex-end;
//   }

//   &__add-button {
//     width: 56px;
//     height: 56px;
//     border-radius: 50%;
//     background-color: #71bd4a;
//     -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     background-image: url(/images/icon/add.svg) !important;
//     background-position: center;
//     background-size: 20px;
//     background-repeat: no-repeat;
//     -webkit-transition: 0.5s;
//     transition: 0.5s;
//     cursor: pointer;
//   }

//   &__add-text {
//     color: #4d4d4d;
//     font-size: 12px;
//     margin-right: 16px;
//     font-family: "SFUIDisplay-Medium";
//   }
// }
// // FILTERS END
</style>
